import { useEffect, useState } from 'react';
import './index.scss';

const OfflineOverlay = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const callback = (event: Event) => {
            if (event.type === 'offline') {
                setVisible(true);
            }
        };
        window.addEventListener('offline', callback);
        return () => {
            window.removeEventListener('offline', callback);
        };
    }, []);

    const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <div className="offline-overlay" style={{ display: visible ? 'flex' : 'none' }}>
            <div className="offline-overlay__refresh" onClick={handleRefresh}>
                刷新页面
            </div>
        </div>
    );
};

export default OfflineOverlay;
